/**
 * Format Number to localeString
 * @param value
 * @param minimumFractionDigits
 * @param maximumFractionDigits
 * @returns string
 */
export const formatNumberToLocale = (value: number, minimumFractionDigits = 2, maximumFractionDigits = 2): string =>
  value.toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits });
